import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import BigNumber from 'bignumber.js';
import { FlexContainer } from '../../styled/layout.styled';
import { H3, Caption } from '../../styled/typograpghy.styled';
import bsvIcon from './assets/bsv-icon.svg';

const StyledFlexContainer = styled(FlexContainer)`
  width: ${({ width }) => width || '100%'};
  background-image: ${({ gradientDirection = false }) => gradientDirection
    ? css`linear-gradient(to bottom, #1a0949, #22096c)`
    : css`linear-gradient(to top, #1a0949, #22096c)`};
  border-radius: 10px 10px 0 0;
  flex-direction: column;
  padding: ${({ padding }) => padding || '24px 0 32px 24px'};
`;

const StyledP = styled(Caption)`
  margin: 0 0 16px 0;
  ${({ campaignBlogCard }) => campaignBlogCard
    ? css`
          color: #c7baf1;
        `
    : ''};
`;

const StyledH3 = styled(H3)`
  img {
    width: 18px;
    margin-left: 4px;
  }
  ${({ campaignBlogCard }) => campaignBlogCard
    ? css`
          color: #ffffff;
          img {
            width: 12px;
            margin-left: 4px;
          }
        `
    : ''}
`;

const DataCard = ({
  width, padding, gradientDirection, name, value, bsIcon, campaignBlogCard,
}) => {
  const splittedValue = new BigNumber(value)
    .toFixed()
    .toString()
    .split('.');
  return (
    <StyledFlexContainer width={width} padding={padding} gradientDirection={gradientDirection}>
      <StyledP campaignBlogCard={campaignBlogCard}>{name}</StyledP>
      <StyledH3 campaignBlogCard={campaignBlogCard}>
        {splittedValue[0]}
        {splittedValue.length === 1 ? '' : '.'}
        <span className="xlarge">{splittedValue[1]}</span>
        {bsIcon ? <img src={bsvIcon} alt="icon" /> : null}
      </StyledH3>
    </StyledFlexContainer>
  );
};

DataCard.propTypes = {
  width: PropTypes.string,
  padding: PropTypes.string,
  gradientDirection: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  bsIcon: PropTypes.bool,
  campaignBlogCard: PropTypes.bool,
};

DataCard.defaultProps = {
  width: '',
  padding: '',
  gradientDirection: false,
  bsIcon: false,
  campaignBlogCard: false,
};

export default DataCard;
